<template>
  <aside class="main-sidebar">
    <section class="sidebar">
      <div class="user-panel">
        <div class="ulogo"></div>
        <div class="left-menu-logo">
          <img src="/resources/logos/BS LOGO_LOGO PLATEADO.png" alt />
        </div>
        
        <div class="info">
          <p>
            Welcome
            <span class="text-yellow text-capitalize">{{
              $store.getters.currentUser.username
            }}</span>
          </p>

          <template v-if="$store.getters.currentUser.rank != 'regular'">
            <p class="m1">
              <img
                class="w-50"
                :src="$store.getters.currentUser.rank_icon"
                alt
              />
            </p>
          </template>

          <router-link to="/profile">
            <i class="ion ion-gear-b"></i>
          </router-link>

          <a class="pointer-cursor" @click.prevent="logout">
            <i class="ion ion-power"></i>
          </a>
        </div>
      </div>
      <!-- sidebar menu -->
      <ul class="sidebar-menu" data-widget="tree">
        <li class="nav-devider"></li>
        <li class="header nav-small-cap">PERSONAL</li>
        <li
          class="treeview"
          :class="this.active === 'dashboard' ? 'active' : ''"
          @click="selected('dashboard')"
        >
          <router-link to="/dashboard">
            <i class="icon-home"></i>
            <span>Dashboard</span>
          </router-link>
        </li>

        <li
          class="treeview"
          :class="this.active === 'plans' ? 'active' : ''"
          @click="selected('plans')"
        >
          <router-link to="/plans">
            <i class="icon-grid"></i>
            <span>Packages</span>
          </router-link>
        </li>
        <li
          class="treeview"
          :class="this.active === 'reports' ? 'active' : ''"
          @click="selected('reports')"
        >
          <router-link to="/reports">
            <i class="mdi mdi-chart-areaspline"></i>
            <span>Reports</span>
          </router-link>
        </li>
        <li
          class="treeview"
          :class="this.active === 'network' ? 'active' : ''"
          @click="selected('network')"
        >
          <router-link to="/network">
            <i class="mdi mdi-source-branch"></i>
            <span>Binary</span>
          </router-link>
        </li>

        <li
          class="treeview"
          :class="this.active === 'my-referrals' ? 'active' : ''"
          @click="selected('my-referrals')"
        >
          <router-link to="/my-referrals">
            <i class="mdi mdi-rocket"></i>
            <span>Unilvel</span>
          </router-link>
        </li>

        <li
          class="treeview"
          :class="this.active === 'leads' ? 'active' : ''"
          @click="selected('leads')"
        >
          <router-link to="/leads">
            <i class="mdi mdi-binoculars"></i>
            <span>Leads</span>
          </router-link>
        </li>

        <li
          class="treeview"
          :class="this.active === 'financial' ? 'active' : ''"
          @click="selected('financial')"
        >
          <router-link to="/financial">
            <i class="mdi mdi-airballoon"></i>
            <span>Packs</span>
          </router-link>
        </li>

        <li class="header nav-small-cap">MY ACCOUNT</li>
        <li
          class="treeview"
          :class="this.active === 'balance' ? 'active' : ''"
          @click="selected('balance')"
        >
          <router-link to="/balance">
            <i class="icon-wallet"></i>
            <span>Wallet</span>
          </router-link>
        </li>
        <li
          class="treeview"
          :class="this.active === 'profile' ? 'active' : ''"
          @click="selected('profile')"
        >
          <router-link to="/profile">
            <i class="mdi mdi-face-profile"></i>
            <span>Profile</span>
          </router-link>
        </li>

        <li
          class="treeview"
          :class="this.active === 'invoices' ? 'active' : ''"
          @click="selected('invoices')"
        >
          <router-link to="/invoices">
            <i class="mdi mdi-barcode"></i>
            <span>Invoices</span>
          </router-link>
        </li>

        <li
          class="treeview"
          :class="this.active === 'marketing' ? 'active' : ''"
          @click="selected('marketing')"
        >
          <router-link to="/marketing">
            <i class="mdi mdi-lightbulb"></i>
            <span>Tools</span>
          </router-link>
        </li>

        <li class="header nav-small-cap">ACTIONS</li>
        <li class="treeview">
          <a class="pointer-cursor" @click.prevent="logout">
            <i class="ion ion-log-out"></i>
            <span>Log Out</span>
          </a>
        </li>
      </ul>
    </section>
  </aside>
</template>

<style lang="scss" scoped>
.left {
  &-menu {
    &-logo {
      margin: 3rem;
    }
  }
}
</style>

<script>
import { userMixin } from "@/mixins";

export default {
  name: "left-menu",
  data() {
    return {
      active: "",
    };
  },
  mixins: [userMixin],
  created() {
    this.active = this.$route.path.split("/")[1];
  },
  methods: {
    selected(link) {
      this.active = link;
      if (window.innerWidth < 767)
        document.querySelector("#toggle-menu").click();
    },
  },
};
</script>
